// Consent Management — GDPR / D.Lgs. 196/2003 compliant
// localStorage-based, with granular categories.

const STORAGE_KEY = "arabell_consent_v2";
const EVENT_NAME = "arabell-consent-change";

export const DEFAULT_CONSENT = {
  necessary: true, // always true (tecnici, non richiedono consenso)
  analytics: false,
  marketing: false,
  timestamp: null,
  version: "2.0",
};

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch {
    return null;
  }
};

export const hasDecided = () => getConsent() !== null;

export const setConsent = (prefs) => {
  const consent = {
    ...DEFAULT_CONSENT,
    ...prefs,
    necessary: true,
    timestamp: new Date().toISOString(),
    version: "2.0",
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: consent }));
  return consent;
};

export const acceptAll = () =>
  setConsent({ necessary: true, analytics: true, marketing: true });

export const rejectAll = () =>
  setConsent({ necessary: true, analytics: false, marketing: false });

export const revokeConsent = () => {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
};

export const onConsentChange = (callback) => {
  window.addEventListener(EVENT_NAME, (e) => callback(e.detail));
  return () => window.removeEventListener(EVENT_NAME, callback);
};
